
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/motorcycle-deals",
      function () {
        return require("private-next-pages/motorcycle-deals.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/motorcycle-deals"])
      });
    }
  